function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState, useMemo, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { T } from 'shared/helper/translate';
import useRepeater from 'researcher/hooks/use-repeater';
import { searchPlagiarism } from 'researcher/plagiarism/actions';
import { NUMBER_OF_SECONDS_BETWEEN_UPDATES, STATUSES } from 'researcher/plagiarism/constants';
import { price } from 'researcher/helpers/price';
import { setError } from '../../actions';
import { RUBRIQ_PLAGIARISM_ERRORS, RUBRIQ_PLAGIARISM_ERROR_MAP } from '../../constants';
import RubriqLoadingSpinner from '../../components/RubriqLoadingSpinner';
import iThenticate from '../../images/ithenticate.svg';
import { getAvailableNewPlans, getPaddlePrices, isPaddlePricesLoading } from '../../reducer';
import sampleReportPdf from '../../../../assets/files/Sample_Plagiarism_Report.pdf';
import understandSampleReportPdf from '../../../../assets/files/Understanding_the_Similarity_Report.pdf';
import RubriqPlagiarismHeader from './RubriqPlagiarismHeader';
import PlagiarismCheckDocumentModal from './PlagiarismCheckDocumentModal';
import RubriqPlagiarismDocumentList from './RubriqPlagiarismDocumentList';
import RubriqPlagiarismNoEditsMessage from './RubriqPlagiarismNoEditsMessage';
import './styles/plagiarism.scss';
var RubriqPlagiarism = function RubriqPlagiarism() {
  var _newPlans$plagiarism;
  var user = useSelector(function (_ref) {
    var user = _ref.user;
    return user;
  });
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    checkDocumentModalOpen = _useState2[0],
    setCheckDocumentModalOpen = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    preUploadedFiles = _useState4[0],
    setPreUploadedFiles = _useState4[1];
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    resetUploadKey = _useState6[0],
    setResetUploadKey = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    dropdownOpen = _useState8[0],
    setDropdownOpen = _useState8[1];
  var dropdownRef = useRef(null);
  var dispatch = useDispatch();
  var _useSelector = useSelector(function (state) {
      return state;
    }),
    plagiarism = _useSelector.plagiarism;
  var documents = plagiarism.plagiarisms,
    status = plagiarism.status,
    processingDocuments = plagiarism.processingDocuments;
  var newPlans = useSelector(getAvailableNewPlans);
  var enablePaddleCountryPrice = true;
  var paddlePrices = useSelector(getPaddlePrices);
  var loadingPaddlePrices = useSelector(isPaddlePricesLoading);
  var getDisplayPrice = function getDisplayPrice(plan, fallbackPrice) {
    if (!enablePaddleCountryPrice || loadingPaddlePrices) {
      return price(user.currency, fallbackPrice, true, true);
    }
    var paddlePrice = paddlePrices[plan === null || plan === void 0 ? void 0 : plan.paddlePlanId];
    if (paddlePrice) {
      return paddlePrice.formatted;
    }
    return price(user.currency, fallbackPrice, true, true);
  };
  var hasProcessingDocuments = useMemo(function () {
    return documents.some(function (doc) {
      var isStatusProcessing = doc.status === STATUSES.STATUS_PROCESSING;
      var isReduxProcessing = processingDocuments[doc.fileIdentity];
      return isStatusProcessing || isReduxProcessing;
    });
  }, [documents, processingDocuments]);
  var _useRepeater = useRepeater({
      fn: function fn() {
        return dispatch(searchPlagiarism());
      },
      numberOfSecondsBetweenCalls: NUMBER_OF_SECONDS_BETWEEN_UPDATES
    }),
    startPolling = _useRepeater.start,
    stopPolling = _useRepeater.stop;
  useEffect(function () {
    dispatch(searchPlagiarism());
  }, [dispatch]);
  useEffect(function () {
    if (hasProcessingDocuments) {
      startPolling();
    } else {
      stopPolling();
    }
    return function () {
      return stopPolling();
    };
  }, [hasProcessingDocuments, startPolling, stopPolling]);
  useEffect(function () {
    var handleClickOutside = function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    if (dropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return function () {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [dropdownOpen]);
  var handleCheckDocument = function handleCheckDocument() {
    setCheckDocumentModalOpen(true);
  };
  var handleError = function handleError(errorId) {
    if (errorId in RUBRIQ_PLAGIARISM_ERROR_MAP) {
      dispatch(setError(RUBRIQ_PLAGIARISM_ERROR_MAP[errorId]));
    } else {
      dispatch(setError(RUBRIQ_PLAGIARISM_ERRORS.UNKNOWN_ERROR));
    }
  };
  var handleFileUploaded = function handleFileUploaded(files) {
    setPreUploadedFiles(files);
    if (!checkDocumentModalOpen) {
      setCheckDocumentModalOpen(true);
    }
  };
  var handleCheckDocumentModalClose = function handleCheckDocumentModalClose(result, errorId) {
    setCheckDocumentModalOpen(false);
    setPreUploadedFiles(null);
    setResetUploadKey(function (prev) {
      return prev + 1;
    });
    if (errorId) {
      handleError(errorId);
    } else if (result) {
      dispatch(searchPlagiarism());
    }
  };
  var toggleDropdown = function toggleDropdown() {
    setDropdownOpen(!dropdownOpen);
  };
  var handleDropdownItemClick = function handleDropdownItemClick() {
    setDropdownOpen(false);
  };
  if (status.searchBusy && documents.length === 0) {
    return /*#__PURE__*/React.createElement(RubriqLoadingSpinner, {
      text: "loading documents"
    });
  }
  var hasDocuments = documents.length > 0;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "rubriq-plagiarism"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-between align-items-start rubriq-plagiarism__header flex-wrap"
  }, /*#__PURE__*/React.createElement("div", {
    className: "rubriq-plagiarism__header-content mb-4 flex-grow-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-between align-items-center gap-3 flex-wrap mb-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "fs-6 fw-semibold lh-base flex-fill"
  }, /*#__PURE__*/React.createElement(T, {
    source: "plagiarism intro %(amount)",
    params: {
      amount: newPlans !== null && newPlans !== void 0 && (_newPlans$plagiarism = newPlans.plagiarism) !== null && _newPlans$plagiarism !== void 0 && _newPlans$plagiarism[0] ? getDisplayPrice(newPlans.plagiarism[0], newPlans.plagiarism[0].price) : null
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center gap-2 flex-shrink-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "dropdown",
    ref: dropdownRef
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-sm btn-outline-secondary dropdown-toggle text-uppercase sample-report-btn",
    type: "button",
    onClick: toggleDropdown,
    "aria-expanded": dropdownOpen
  }, /*#__PURE__*/React.createElement(T, {
    source: "sample-report"
  }), /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-caret-down"
  })), /*#__PURE__*/React.createElement("ul", {
    className: "dropdown-menu ".concat(dropdownOpen ? 'show' : ''),
    onMouseLeave: handleDropdownItemClick
  }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    className: "dropdown-item",
    href: sampleReportPdf,
    target: "_blank",
    rel: "noreferrer",
    onClick: handleDropdownItemClick
  }, /*#__PURE__*/React.createElement(T, {
    source: "view-sample-report"
  }))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    className: "dropdown-item",
    href: understandSampleReportPdf,
    target: "_blank",
    rel: "noreferrer",
    onClick: handleDropdownItemClick
  }, /*#__PURE__*/React.createElement(T, {
    source: "understand-sample-report"
  }))))))), /*#__PURE__*/React.createElement("div", {
    className: "mt-3 d-flex align-items-end"
  }, /*#__PURE__*/React.createElement("div", {
    className: "powered-by small text-secondary"
  }, /*#__PURE__*/React.createElement(T, {
    source: "powered_by"
  }), /*#__PURE__*/React.createElement("img", {
    style: {
      marginTop: '-5px'
    },
    src: iThenticate,
    alt: "",
    className: "ms-1"
  })))), hasDocuments && /*#__PURE__*/React.createElement("div", {
    className: "flex-shrink-0"
  }, /*#__PURE__*/React.createElement(RubriqPlagiarismHeader, {
    onCheckDocument: handleCheckDocument
  }))), hasDocuments ? /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column gap-4"
  }, /*#__PURE__*/React.createElement(RubriqPlagiarismDocumentList, {
    documents: documents,
    status: status
  })) : /*#__PURE__*/React.createElement("div", {
    className: "rubriq-plagiarism__container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "rubriq-plagiarism__instruction-box"
  }, /*#__PURE__*/React.createElement(T, {
    source: "tracked_changes_warning"
  })), /*#__PURE__*/React.createElement("div", {
    className: "rubriq-plagiarism__upload-area"
  }, /*#__PURE__*/React.createElement(RubriqPlagiarismNoEditsMessage, {
    key: resetUploadKey,
    onFileUploaded: handleFileUploaded
  })))), /*#__PURE__*/React.createElement(PlagiarismCheckDocumentModal, {
    open: checkDocumentModalOpen,
    onClose: handleCheckDocumentModalClose,
    initialFiles: preUploadedFiles
  }));
};
export default RubriqPlagiarism;